import { isEmpty } from 'lodash';
import { raiseErrorToast, useIdentificationContext } from '@fiverr-private/identification_core';
import { UseFormSetError } from '@fiverr-private/forms';
import { ProfileSetupFormSchema } from '../ProfileSetupStep.schema';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../../../events';
import { translate } from '../../../../utils/translate';
import { useStepsContext } from '../../../StepsContext';
import { useSignUpContext } from '../../../SignUpContext';

export const useProfileSubmitHandler = ({
    setError,
    setLoading,
}: {
    setError: UseFormSetError<ProfileSetupFormSchema>;
    setLoading(v: boolean): void;
}) => {
    const { isSocialFlow, email, password, setUserName } = useIdentificationContext();
    const { signUp, createOrganization, checkInvitation } = useSignUpContext();
    const { goToStep } = useStepsContext();

    const onSubmit = async (data: ProfileSetupFormSchema) => {
        setLoading(true);
        try {
            globalGrafanaReporter.count('identification.%{platform}.profile_setup.submit');
            globalBigQueryReporter.send('identification.profile_setup.submit');

            const userResult = await signUp({
                isSocialFlow,
                email,
                password: password || '',
                username: data.username,
                firstName: data.firstName,
                lastName: data.lastName,
            });

            setUserName(data.username);

            if (!userResult) {
                return;
            }

            if (userResult.errorKeys && !isEmpty(userResult.errorKeys)) {
                const errorKeys = userResult.errorKeys;
                const error = errorKeys.username?.length ? errorKeys.username[0] : 'unspecified';

                setError('username', {
                    message: translate(`validation.username.${error}`),
                });
                return;
            }

            const hasInvitation = await checkInvitation(email);
            if (hasInvitation) {
                goToStep('invitation', { resetHistory: true });
                return;
            }

            await createOrganization();
        } catch (err) {
            raiseErrorToast();
        } finally {
            setLoading(false);
        }
    };

    return {
        onSubmit,
    };
};
